
import "whatwg-fetch";
import Cookies from 'js-cookie';

const defaultConfig = {
	credentials: 'same-origin',
	redirect: 'follow',
};

export const defaultHeaders = {
	'Content-Type': 'application/json',
	'Accept': 'application/json',
};

export default function doFetch(url, config = {}) {
	if (!config.headers) {
		config.headers = {};
	}
	
	const csrfHeaders = {};
	
	if ('csrfToken' in window && window.csrfToken) {
		csrfHeaders['X-CSRF-TOKEN'] = window.csrfToken;
	}
	
	const xsrf_token = Cookies.get('XSRF-TOKEN');
	if (xsrf_token) {
		csrfHeaders['X-XSRF-TOKEN'] = xsrf_token;
	}
	
	return fetch(`${ url }`, {
		...defaultConfig,
		...config,
		headers: {
			...defaultHeaders,
			...csrfHeaders,
			...config.headers
		}
	});
}

export function get(url, config = {}) {
	return doFetch(url, config);
}

export function post(url, config = {}) {
	return doFetch(url, {
		method: 'post',
		...config
	});
}

export function put(url, config = {}) {
	return doFetch(url, {
		method: 'put',
		...config
	});
}

export function destroy(url, config = {}) {
	return doFetch(url, {
		method: 'delete',
		...config
	});
}

export function postJson(url, data, config = {}) {
	return post(url, {
		...config,
		body: JSON.stringify(data),
	});
}

export function putJson(url, data, config = {}) {
	return put(url, {
		...config,
		body: JSON.stringify(data),
	});
}
